import { render } from "./DiyModalDeclare.vue?vue&type=template&id=324ac6aa&scoped=true"
import script from "./DiyModalDeclare.vue?vue&type=script&lang=js"
export * from "./DiyModalDeclare.vue?vue&type=script&lang=js"

import "./DiyModalDeclare.vue?vue&type=style&index=0&id=324ac6aa&scoped=true&lang=css"
import "./DiyModalDeclare.vue?vue&type=style&index=1&id=324ac6aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LewisLi\\workitem\\th workspace\\th_fe\\tiffanyFE-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324ac6aa"]])

export default __exports__